// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  subadmin: {
    create: path(ROOTS_DASHBOARD, '/subadmin/create'),
    list: path(ROOTS_DASHBOARD, '/subadmin/list'),
    edit: path(ROOTS_DASHBOARD, '/subadmin/edit'),

  },
  seller: {
    create: path(ROOTS_DASHBOARD, '/seller/create'),
    list: path(ROOTS_DASHBOARD, '/seller/list'),
    edit: path(ROOTS_DASHBOARD, '/seller/edit'),

  },
 
  dashboard:{
    app: path(ROOTS_DASHBOARD, '/'),
    home:path(ROOTS_DASHBOARD, '/home'),
    users:path(ROOTS_DASHBOARD, '/users'),
    blog:path(ROOTS_DASHBOARD, '/blog'),
    applications:path(ROOTS_DASHBOARD, '/applications'),
    employee:path(ROOTS_DASHBOARD, '/hidden-employee'),
    applicationFiles:path(ROOTS_DASHBOARD, '/application-files'),
  }
 
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
